"use client";
import type { Interpolation } from "@emotion/react";
import { I18nMessage } from "@i18n/next";
import {
  Notice,
  NoticeIcon,
  spacing,
  Text,
  type ThemeType,
} from "@packages/ui";

import type enMessages from "../../../../messages/en.json";

const iconStyle: Interpolation<ThemeType> = (theme) => ({
  background: theme.semanticColors.background,
  borderRadius: theme.radius.full,
  color: theme.semanticColors.warning,
  marginRight: theme.spacing.ms,
});

const noticeStyle: Interpolation = {
  marginBlock: spacing.l,
};

export const WarningNotice = ({
  className = "",
  message,
}: {
  className?: string;
  message: keyof typeof enMessages;
}) => (
  <Notice
    variant="warning"
    icon={
      <NoticeIcon.Circled viewBox="-8 -8 40 40" size={40} css={iconStyle} />
    }
    css={noticeStyle}
    className={className}
  >
    <Text size="s">
      <I18nMessage message={message} />
    </Text>
  </Notice>
);
